<div [class]="(mobile$ | async) ? 'app-datatable mobile' : 'app-datatable'">
  <div *ngIf="loading$ | async as loading">
    <div *ngIf="loading === true" class="loader">
      <mat-spinner></mat-spinner>
    </div>
  </div>
  <div fxLayout="row wrap" fxLayoutAlign="space-between">
    <div>
      <ng-container *ngTemplateOutlet="tableHeader">
      </ng-container>
    </div>
    <div *ngIf="filterConfig.showGlobalFilter" fxLayout="row" fxLayoutAlign="end">
      <nc-text-filter [formGroup]="filterConfig.globalFilterFormGroup" [filterName]="GLOBAL_FILTER_NAME"></nc-text-filter>
    </div>
  </div>
  <table mat-table
         [dataSource]="dataSource"
         matSort
         [id]="'nc-datatable-' + id"
         [matSortActive]="sortTableColumn"
         [matSortDirection]="sortTableByAscOrDesc">
    <!--  Data rendering-->
    <ng-container [matColumnDef]="column.name" *ngFor="let column of columns">
      <th mat-header-cell mat-cell *matHeaderCellDef mat-sort-header [disabled]="!column.sortable">
        <span *ngIf="column.type !== 'CHECKBOX_COLUMN'" [class.align-center]="column.alignment === alignmentType.ALIGN_CENTER"
              [class.align-left]="column.alignment === alignmentType.ALIGN_LEFT"
              [class.align-right]="column.alignment === alignmentType.ALIGN_RIGHT"> {{column.label | translate}} </span>
        <span *ngIf="column.type === 'CHECKBOX_COLUMN'">
          <nc-checkbox-cell-header [selectConfig]="selectConfig" [data]="dataSource.data"></nc-checkbox-cell-header>
        </span>
      </th>
      <td mat-cell *matCellDef="let rowData" [class.icon]="hasIcon(column)">
        <nc-cell-dispatcher [selectConfig]="selectConfig" [column]="column" [rowData]="rowData"></nc-cell-dispatcher>
      </td>
      <ng-container *ngIf="isTotalVisible">
        <td class="footer-row" mat-footer-cell *matFooterCellDef>{{totalRowData[column.name]}} </td>
      </ng-container>
    </ng-container>

    <!--  Filters rendering-->
    <ng-container [matColumnDef]="column.filterName" *ngFor="let column of columns">
      <th mat-header-cell *matHeaderCellDef [formGroup]="filterConfig.columnFiltersFormGroup" class="header-filter">
        <nc-filter-dispatcher [formGroup]="filterConfig.columnFiltersFormGroup" [column]="column"></nc-filter-dispatcher>
      </th>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <ng-container *ngIf="filterConfig.showFilter">
      <tr mat-header-row *matHeaderRowDef="columnsFilters" class="filter"></tr>
    </ng-container>
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay;" [class.pointer]="hasPointer()" [class.invalid-row]='row.isInvalid'
        [class.important-row]="row.important === 'true'"
        (click)="onRowClick(row)"></tr>
    <ng-container *ngIf="isTotalVisible">
      <tr mat-footer-row *matFooterRowDef="columnsToDisplay"></tr>
    </ng-container>
  </table>

  <mat-paginator *ngIf="hasPaginator" [length]="dataLength" [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
</div>
